export default {
    name: "unauthorized",
    components: {},
    props: [],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
